import { OrderedSet } from 'immutable';
import { ContentType } from '../notebook.types';

export abstract class NotebookCellFacade {
  abstract editCellContent(content: string, cellToken: string): void;
  abstract beginEditCell(cellToken: string, cellFrozen?: boolean): void;
  abstract updateContentType(cellToken: string, contentType: ContentType): void;
  abstract selectCell(cellToken: string, resultPane?: boolean): void;
  abstract addCell({
    notebookToken,
    content,
    contentType,
    nextToken,
  }: {
    notebookToken: string;
    content?: string;
    contentType?: ContentType;
    nextToken?: string;
  }): void;
  abstract moveCell(cellToken: string, down: boolean): void;
  abstract addCellToLayout(cellToken: string): void;
  abstract foldCell(cellToken: string): void;
  abstract toggleFreezeCell(cellToken: string): void;
  abstract removeCellFromLayout(cellToken: string): void;
  abstract destroyCell(
    cellToken: string,
    nextCellToken: string,
    notebookToken: string,
    notebookCellTokensArray: Map<string, OrderedSet<string>>
  ): void;
  abstract updateCell(cellToken: string): void;
  abstract removeCell(notebookToken: string, cellToken: string): void;
  abstract runCell(notebookToken: string, cellToken: string): void;
}
